// apps/admin/src/lib/sessionHint.ts
//
// Tiny localStorage flag used to skip the bootstrap /auth/me +
// /auth/me/permissions calls when we know there's no session to validate.
// The auth cookie itself is HttpOnly and unreadable from JS, so we use this
// non-secret hint solely as a "is there any chance the user is signed in?"
// gate. Source of truth remains the cookie/server.
//
// Lifecycle:
//   setSessionHint()    — after successful login or successful /auth/me
//   clearSessionHint()  — on explicit logout or a 401 from /auth/me
//
// Without this gate, a cold load on `/` renders AdminAppShellLayout once
// before the redirect to `/login`, which fired 4× 401 console errors
// (/auth/me + /auth/me/permissions, each from two stores).

const KEY = 'pw_admin_session_hint';

export function setSessionHint(): void {
  try {
    localStorage.setItem(KEY, '1');
  } catch {
    /* private mode / quota — silently ignore */
  }
}

export function clearSessionHint(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

export function hasSessionHint(): boolean {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}
